import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Gallery from './views/Gallery.vue'
import Contact from './views/Contact.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta:{
        title: 'Sousa Branco - artista plástico'
      }
    },
    {
      path: '/sobre',
      name: 'sobre',
      component: About,
      meta:{
        title:'Sobre - Sousa Branco'
      }
    },
    {
      path: '/galeria',
      name: 'galeria',
      component: Gallery,
      meta:{
        title:'Galeria - Sousa Branco'
      }
    },
    {
      path: '/contato',
      name: 'contato',
      component: Contact,
      meta:{
        title:'Contato - Sousa Branco'
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
